import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHero,
  StyledWrapper
} from './BattleReportHero.styled';

const BattleReportHero: React.FC = () => {
  const { t } = useI18n('battle-report');

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <div>
            <Heading1>{t('battle-report.hero.title')}</Heading1>
            <p>
              <HtmlTrans ns="battle-report" i18nKey="battle-report.hero.desc" />
            </p>
          </div>
          <img
            src={getPublicPath(`/images/battleReport/satellite.svg`)}
            alt=""
          />
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default BattleReportHero;
